import { render, staticRenderFns } from "./vipMain.vue?vue&type=template&id=34765cae&scoped=true"
import script from "./vipMain.vue?vue&type=script&lang=js"
export * from "./vipMain.vue?vue&type=script&lang=js"
import style0 from "./vipMain.vue?vue&type=style&index=0&id=34765cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34765cae",
  null
  
)

export default component.exports